import { Tooltip } from '@mui/material';
import { ReactNode } from 'react';

interface FieldLabelProps {
  label: string;
  description?: string;
}

/**
 * Renders a field label with an optional tooltip showing the description on hover.
 * If no description is provided, renders the label as plain text.
 */
export function FieldLabel({ label, description }: FieldLabelProps): ReactNode {
  // Filter out unresolved JSON Forms i18n keys (e.g. "transType.description")
  const isUnresolved = description?.endsWith('.description') && !description.includes(' ');
  if (!description || description === label || isUnresolved) {
    return label;
  }

  return (
    <Tooltip title={description} placement="top" arrow enterDelay={400}>
      <span>{label}</span>
    </Tooltip>
  );
}
